class DocumentContent {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.documentNavItems = self.elem.querySelectorAll('[data-document-nav-item]');
        self.documentSections = self.elem.querySelectorAll('[data-document-section]');
    }

    init() {
        let self = this;

        self.setActiveLink = self.setActiveLink.bind(self);

        self.setActiveLink();
        self.scrollToSection();

        window.addEventListener('scroll', self.setActiveLink);
    }

    setActiveLink() {
        let self = this;

        let index = self.documentSections.length;

        // Find the section that is currently in view
        while (--index && window.scrollY + 200 < self.documentSections[index].offsetTop) {}

        // Remove all active states
        self.documentNavItems.forEach((link) => {
            link.classList.remove('active');
        });

        // Apply active state to scrolled section link
        if (index >= 0) {
            self.documentNavItems[index].classList.add('active');
        }
    }

    scrollToSection() {
        let self = this;

        self.documentNavItems.forEach((navItem, index) => {
            navItem.addEventListener('click', (event) => {
                event.preventDefault();

                // Remove active state from all links
                self.documentNavItems.forEach((link) => {
                    link.classList.remove('active');
                });

                // Apply active state to clicked link
                navItem.classList.add('active');

                // Scroll to the relevant section
                window.scrollTo({
                    top: self.documentSections[index].offsetTop - 100,
                    behavior: 'smooth'
                });
            });
        });
    }
}

export default DocumentContent;
